<template>
  <div class="md-layout" v-on:keyup.enter="login(identityServerProvider)">
    <div class="text-center md-layout-item md-medium-size-100 md-size-100">
      <img src="@/assets/0_CNE Light.png" class="mt-3" style="width: 400px" />

      <div class="my-6">
        <span style="font-size: 35px">Bienvenue sur le</span>
        <br />
        <span style="font-size: 35px; font-weight: bold">Cahier Numérique de l'Entraîneur</span>
      </div>

      <div class="my-6">
        <v-form ref="loginForm">
          <div class="row justify-content-center">
            <div class="col-8 col-sm-6 col-md-5 col-lg-4 col-xl-2">
              <!-- username -->
              <v-row>
                <v-col>
                  <v-text-field v-model="credentials.username" label="Email" :rules="[rules.required]" />
                </v-col>
              </v-row>

              <!-- Password -->
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="credentials.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    label="Mot de passe"
                    @click:append="showPassword = !showPassword"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Login with identity server -->
              <v-row>
                <v-col>
                  <v-btn v-on:click="login(identityServerProvider)" color="primary" dark class="mb-2" elevation="2"> Se Connecter </v-btn>
                </v-col>
              </v-row>

              <!-- Line spacer -->
              <v-row>
                <v-col>
                  <hr />
                </v-col>
              </v-row>

              <!-- Login with ADFS -->
              <v-row>
                <v-col>
                  <v-btn v-on:click="login(adfsProvider)" color="secondary" dark class="mb-2" elevation="2"> ADFS </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/AuthService";
import { AuthProviderType } from "@/models/enums";
import store from "@/store";

export default {
  data() {
    return {
      identityServerProvider: AuthProviderType.IDENTITY_SERVER,
      adfsProvider: AuthProviderType.ADFS,
      credentials: {
        username: "",
        password: "",
      },
      showPassword: false,
      rules: {
        required: (value) => !!value || "Requis.",
      },
    };
  },

  mounted() {
    // First of all, we wanna reset the current number of requests in the state to prevent infinite loader
    store.dispatch("resetCurrentNumberOfRequests");

    AuthService.registerAuthenticatedCallback(() => this.onAuthenticated());

    // If already logged in, redirect to /hub
    if (AuthService.isConnected) {
      this.redirectToHubOrRedirectUrl();
    }
  },

  beforeDestroy() {
    AuthService.removeAuthenticatedCallback(() => this.onAuthenticated());
  },

  methods: {
    login(provider) {
      var canLogin = false;
      var adfs = false;

      // If we try to login using username password we wanna submit the form
      if (provider === AuthProviderType.IDENTITY_SERVER) {
        canLogin = this.$refs.loginForm.validate();
      } else {
        //canLogin = true;
        adfs = true;
        store.dispatch("setSnackbar", {
          title: "Authentification ADFS",
          text: "Ce moyen d'authentification n'est pas encore implémenté.",
          status: "warning",
          timeout: 2000,
        });
      }

      // If we can login
      if (canLogin) {
        AuthService.login(provider, this.credentials);
      }
      // Else display form errors
      else {
        // Handle missing email
        if (!adfs && !this.credentials.username) {
          store.dispatch("setSnackbar", {
            title: "Email requis",
            text: "Veuillez renseigner votre email.",
            status: "error",
            timeout: 2000,
          });
        }
        // Handle missing password
        if (!adfs && !this.credentials.password) {
          store.dispatch("setSnackbar", {
            title: "Mot de passe requis",
            text: "Veuillez renseigner votre mot de passe.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },

    onAuthenticated() {
      this.redirectToHubOrRedirectUrl();
    },

    // Redirect to /hub if no redirect parameter, and to the redirect url if there is any
    redirectToHubOrRedirectUrl() {
      const redirectParam = this.$route.query.redirect;

      // If there is a redirect param, we wanna redirect to this url
      if (redirectParam) {
        this.$router.push(redirectParam);
      }
      // else we wanna redirect to hub
      else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss">
// iframe {
//   width: 100%;
//   height: 600px;
// }
</style>
